/* eslint-disable import/prefer-default-export */
import { schema, normalize } from 'normalizr';
import {
  GET_FILTERS_START,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_ERROR,
  SET_CUSTOM_FILTERS,
  RESET_CUSTOM_FILTERS,
} from '../constants';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

const optionSet = options => ({
  label: options.label,
  labelEn: options.label_en,
  value: options.value,
  selected: false,
  id: options.name,
});

const apiToFilters = filter => {
  const indOptionList = new schema.Entity('indOptions');
  const optionLists = new schema.Array(indOptionList);
  const normalFilters = new schema.Entity('indFilter');
  const normalFilterList = new schema.Array(normalFilters);
  const filtersets = filter.filter_set.map(filterSet => ({
    id: filterSet.order,
    label: filterSet.name,
    desc: filterSet.description,
    options: filterSet.filteroption_set.map(optionSet),
    deeper: normalize(filterSet.filteroption_set.map(optionSet), normalFilterList),
  }));
  return {
    label: filter.name,
    id: filter.order,
    optionGroups: filtersets,
    stupid: normalize(filtersets, optionLists),
  };
};

// export const getFilters = url => async (dispatch, getState, { fetch }) => {
export const getFilters = ({ processName = 'high-school' }) => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { user, intl, admissionInstances } = getState();
  const { locale } = intl;
  const processId = admissionInstances[processName];
  let { applicationId } = user;
  let url = `${locale}/api/${apiVersion}/filters/application/${applicationId}/`;
  if (applicationId === '') {
    applicationId = false;
    url = `${locale}/api/${apiVersion}/filters/process/${processId}/`;
  }
  const indFilter = new schema.Entity('filter', {}, { idAttribute: 'label' });
  const filterList = new schema.Array(indFilter);
  dispatch({ type: GET_FILTERS_START });
  return fetch(url, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(data => {
      const results = data.results.map(apiToFilters);
      const test = normalize(results, filterList);
      dispatch({ type: GET_FILTERS_SUCCESS, payload: { filters: results, test } });
    })
    .catch(error => {
      console.error('error', error);
      dispatch({
        type: GET_FILTERS_ERROR,
        payload: {
          error,
        },
      });
    });
};

export const setCustomFilters = payload => async dispatch => {
  dispatch({ type: SET_CUSTOM_FILTERS, payload });
  return Promise.resolve();
};

export const resetCustomFilters = () => ({ type: RESET_CUSTOM_FILTERS });
